import * as $ from "jquery";
import * as moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { DemandeDpaeDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeDpaeDto";
import { DemandeDpaeEtatEnum } from "../../../dto/GenApi.iNotPaie.Dto/DemandeDpaeEtatEnum";
import { DpaeErreurDto } from "../../../dto/GenApi.iNotPaie.Dto/DpaeErreurDto";
import { LigneDemandeDpaeDto } from "../../../dto/GenApi.iNotPaie.Dto/LigneDemandeDpaeDto";
import Form from "../../../shared/components/forms/Form";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { DataForm, dataFormBase } from "./demandeDpaeModel";

@Component
export default class ModalDemandeDpae extends Vue {
    public demandeDpae?: DemandeDpaeDto;
    public ligneDemandeDpae?: LigneDemandeDpaeDto;
    public dataReady: boolean = false;
    public isFormError: boolean = true;
    public isEnvoyerDisabled: boolean = false;
    public dataForm: DataForm = this.copy(dataFormBase);
    public formDemandeDpae?: Form = undefined;
    public listeErreursBloquantes: DpaeErreurDto[] = [];

    public mounted(): void {
        this.dataReady = false;
        this.formDemandeDpae = <Form>this.$refs.formDemandeDpae;
    }

    public init(ligneDemandeDpae: LigneDemandeDpaeDto): void {
        // Remise a zéro pour la réouverture de la popup
        this.ligneDemandeDpae = ligneDemandeDpae;
        this.resetForm();
        $("#modalDemandeDpae").modal("show");

        if (ligneDemandeDpae.Etat === undefined || ligneDemandeDpae.Etat == DemandeDpaeEtatEnum.ARealiser) {
            // Demandes à réaliser ou non conformes
            ServicesFactoryInstance.DpaeService.getDemandeDpaeFromContrat(ligneDemandeDpae.IdContrat, data => {
                this.demandeDpae = data;
                this.chargeDataForm();

                this.checkFormulaireSuccess(() => {
                    this.isEnvoyerDisabled = false;
                    this.dataReady = true;
                }, () => {
                    this.isEnvoyerDisabled = true;
                    this.dataReady = true;
                });
            }, () => {
                NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération du récapitulatif DPAE.");
                this.close();
            });
        } else if (ligneDemandeDpae.IdDemandeHistorique !== undefined) {
            // Demandes conformes ou envoyées
            ServicesFactoryInstance.DpaeService.getDemandeDpaeFromHistorique(ligneDemandeDpae.IdDemandeHistorique, data => {
                this.demandeDpae = data;
                this.chargeDataForm();

                this.checkFormulaireSuccess(() => { });

                // Récupération de la liste des erreurs
                if (this.ligneDemandeDpae?.Etat == DemandeDpaeEtatEnum.NonConforme) {
                    this.getListeErreurs(this.ligneDemandeDpae.IdDemandeHistorique!);
                } else {
                    this.dataReady = true;
                }
            }, () => {
                NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération du récapitulatif DPAE.");
                this.close();
            });
        }
    }

    public envoyerDemandeDpae(): void {
        if (this.demandeDpae === undefined || this.formDemandeDpae === undefined) {
            return;
        }

        // Bloque les envois doubles
        this.dataReady = false;
        this.isEnvoyerDisabled = true;

        ServicesFactoryInstance.DpaeService.creerEtDeposerDemandeDpae(this.demandeDpae!, () => {
            NotificationServiceInstance.SendSuccess("Demande envoyée.");
            this.$emit("demandeCreee");
            this.close();
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur est survenue pendant l'envoi.");
            this.close();
        });
    }

    public openModalAlerteRenvoiDpae(): void {
        if (this.demandeDpae === undefined)
            return;

        this.close();
        this.$emit("openModalAlerteRenvoiDpae", this.demandeDpae);
    }

    public getListeErreurs(idDemande: number): void {
        ServicesFactoryInstance.DpaeService.getDemandeErreurs(idDemande, data => {
            this.listeErreursBloquantes = data.filter(e => e.Categorie == "bloquant");
            this.dataReady = true;
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération des erreurs de la demande.");
            this.dataReady = true;
        });
    }

    public accederFicheSalarie(idSalarie: string, titre: string): void {
        this.close();
        EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: titre } });
    }

    private close(): void {
        $("#modalDemandeDpae").modal("hide");
    }

    private resetForm(): void {
        this.dataReady = false;
        this.isFormError = false;
        this.formDemandeDpae = <Form>this.$refs.formDemandeDpae;
        this.formDemandeDpae.resetState();
        this.formDemandeDpae.clear();
        this.dataForm = this.copy(dataFormBase);
    }

    private chargeDataForm(): void {
        if (this.demandeDpae === undefined) {
            return;
        }

        this.dataForm.siret.vmodel = this.demandeDpae.Siret ? this.demandeDpae.Siret.toString() : "";
        this.dataForm.codeUrssaf.vmodel = this.demandeDpae.CodeUrssaf ? this.demandeDpae.CodeUrssaf : "";
        this.dataForm.codeNaf.vmodel = this.demandeDpae.CodeNaf ? this.demandeDpae.CodeNaf : "";
        this.dataForm.raisonSociale.vmodel = this.demandeDpae.RaisonSociale ? this.demandeDpae.RaisonSociale : "";
        this.dataForm.raisonSociale2.vmodel = this.demandeDpae.RaisonSociale2 ? this.demandeDpae.RaisonSociale2 : "";
        this.dataForm.codePostalEtablissement.vmodel = this.demandeDpae.CodePostalEtablissement ? this.demandeDpae.CodePostalEtablissement : "";
        this.dataForm.communeEtablissement.vmodel = this.demandeDpae.CommuneEtablissement ? this.demandeDpae.CommuneEtablissement : "";
        this.dataForm.adresseEtablissement.vmodel = this.demandeDpae.AdresseEtablissement ? this.demandeDpae.AdresseEtablissement : "";
        this.dataForm.nomNaissanceSalarie.vmodel = this.demandeDpae.NomNaissanceSalarie ? this.demandeDpae.NomNaissanceSalarie : "";
        this.dataForm.prenomSalarie.vmodel = this.demandeDpae.PrenomSalarie ? this.demandeDpae.PrenomSalarie : "";
        this.dataForm.dateNaissanceSalarie.vmodel = this.demandeDpae.DateNaissanceSalarie != undefined ? moment(this.demandeDpae.DateNaissanceSalarie).format("YYYY-MM-DD") : "";
        this.dataForm.communeNaissanceSalarie.vmodel = this.demandeDpae.CommuneNaissanceSalarie ? this.demandeDpae.CommuneNaissanceSalarie : "";
        this.dataForm.paysNaissanceSalarie.vmodel = this.demandeDpae.PaysNaissanceSalarie ? this.demandeDpae.PaysNaissanceSalarie : "";
        this.dataForm.departementNaissanceSalarie.vmodel = this.demandeDpae.DepartementNaissanceSalarie ? this.demandeDpae.DepartementNaissanceSalarie : "";
        this.dataForm.numSecuriteSocialeSalarie.vmodel = this.demandeDpae.NumSecuriteSocialeSalarie ? this.demandeDpae.NumSecuriteSocialeSalarie : "";
        this.dataForm.dateEmbauche.vmodel = this.demandeDpae.DateDebutContrat != undefined ? moment(this.demandeDpae.DateDebutContrat).format("YYYY-MM-DD") : "";
        this.dataForm.serviceSanteContrat.vmodel = this.demandeDpae.ServiceSanteContrat ? this.demandeDpae.ServiceSanteContrat : "";
        this.dataForm.dureePeriodeEssai.vmodel = this.calculerTempsPeriodeEssai(this.demandeDpae.DateDebutContrat, this.demandeDpae.Duree);
        this.dataForm.heureEmbauche.vmodel = this.demandeDpae.DateDebutContrat != undefined ? this.demandeDpae.DateDebutContrat.toString() : "8:00";
        this.dataForm.natureContrat.vmodel = this.demandeDpae.NatureContrat ? this.demandeDpae.NatureContrat : "";
        this.dataForm.dateFinCdd.vmodel = this.demandeDpae.DateFinCdd != undefined ? moment(this.demandeDpae.DateFinCdd).format("YYYY-MM-DD") : "";
        this.dataForm.dateDepotDemande.vmodel = this.demandeDpae.DateDepotDemande != undefined ? moment(this.demandeDpae.DateDepotDemande).format("YYYY-MM-DD HH:mm") : "";
    }

    private checkFormulaireSuccess(successFunction: () => void, errorFunction?: () => void) {
        this.formDemandeDpae = <Form>this.$refs.formDemandeDpae;
        if (this.formDemandeDpae === undefined) {
            return false;
        }

        this.formDemandeDpae.trigger();

        setTimeout(() => {
            if (this.formDemandeDpae!.checkSuccess()) {
                if (successFunction != undefined) {
                    this.isFormError = false;
                    successFunction();
                }
            } else {
                if (errorFunction != undefined) {
                    this.isFormError = true;
                    errorFunction();
                }
            }
        }, 1);
    }

    private copy(data): any {
        const copied = JSON.parse(JSON.stringify(data));

        return copied;
    }

    private calculerTempsPeriodeEssai(startDate?: Date, duree?: string): string {
        if (startDate == undefined || duree == undefined) {
            return "";
        }

        let start = moment(startDate);
        let end = start.clone().add(duree, 'days');

        let months = end.diff(start, 'months');
        start.add(months, 'months');

        let days = end.diff(start, 'days');

        if (months > 0 && days > 0) {
            return `${months} mois et ${days} jours`;
        } else if (months > 0) {
            return `${months} mois`;
        } else if (days > 0) {
            return `${days} jours`;
        }

        return "";
    }
}



// WEBPACK FOOTER //
// ./src/components/dpae/modalDemandeDpae/modalDemandeDpae.ts